import { BaseComponent } from "../webComponents/BaseComponent";
import { Filter, SearchRequest } from "../../openApiClients/generated/EngineeringUK.Sites";

const defaultPageSize = 10;
const defaultPage = 1;
const defaultSkip = 0;

export class SearchBaseComponent extends BaseComponent {
  readonly requestUpdateEvent: string = "request-update";
  readonly resultUpdateEvent: string = "result-update";

  constructor() {
    super();
  }

  updateRequestUrl(searchRequest: SearchRequest) {
    if (!("URLSearchParams" in window)) {
      return;
    }
    const url = new URL(location.href);
    const setParamIfNotDefault = function<T>(key: string, value: T, defaultValue: T) {
      if (value && value !== defaultValue) {
        url.searchParams.set(key, value.toString());
        return;
      }
      url.searchParams.delete(key);
    };
    const processFilters = (filters: Filter[] | null, prefix: string) => {
      if (filters === null) {
        return;
      }
      filters?.forEach((filter) => {
        const selectedOptions = filter.options?.filter(x => x.selected).map(x => x.value) ?? [];
        const key = `${prefix}.${filter.id}`;

        if (selectedOptions?.length > 0) {
          url.searchParams.set(key, selectedOptions.join(","));
        }
        else {
          url.searchParams.delete(key);
        }
      });

      // Remove any filters that are not present in the request
      [...url.searchParams.keys()]
        .filter(key => key.startsWith(prefix))
        .forEach((key) => {
          if (!filters?.some(filter => key === `${prefix}.${filter.id}`)) {
            url.searchParams.delete(key);
          }
        });
    };
    setParamIfNotDefault<number>("page", searchRequest.page, defaultPage);
    setParamIfNotDefault<number>("pageSize", searchRequest.pageSize, defaultPageSize);
    setParamIfNotDefault<number>("skip", searchRequest.skip, defaultSkip);
    setParamIfNotDefault<string>("term", searchRequest.term ?? "", "");
    setParamIfNotDefault<string>("facets", searchRequest.facets?.join(",") ?? "", "");
    processFilters(searchRequest.filters, "filters");
    processFilters(searchRequest.preFilters, "preFilters");

    history.pushState(null, "", url);
  }
}
